export const enum PREMIUM {
  MESSAGE = 'check-subscription',
  PAID = 'PAID',
}

export const enum PLAN {
  FREE = 'free',
  PREMIUM = 'premium',
}
